
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Category,
  Content,
  Tag,
  ContentFile,
} from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DateUtil } from "@/script/core/util/DateUtil";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import TinymceEditor from "@/components/TinymceEditor.vue";
import TinymceMobileEditor from "@/components/TinymceMobileEditor.vue";
import { TagService } from "@/script/apps/cms/service/TagService";
import { AppConfig } from "@/script/core/base/AppConfig";
import { ElMessage } from "element-plus";
import { CallBack } from "@/script/core/service/DataService";
import { Custom, CustomDetail } from "@/script/apps/system/entity/SystemEntity";
import store from "@/store";
import CategoryRefer from "../category/CategoryRefer.vue";
import ContentRefer from "./ContentRefer.vue";

@Options({
  components: {
    TinymceEditor,
    TinymceMobileEditor,
    CategoryRefer,
    ContentRefer,
  },
})
export default class ContentDetail extends BaseDetail {
  public refreshKey = 1;

  public hasExtend = false;

  public parents: Category[] = [];

  public tagValues: number[] = [];

  public tagOptions: any[] = [];

  public customDetails: CustomDetail[] = [];
  public generalCustomDetails: CustomDetail[] = [];
  public textareaCustomDetails: CustomDetail[] = [];

  public service = new ContentService();

  public rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],
    content: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (this.entity.type === "content") {
            if (this.entity.content === null) {
              callback(new Error("请输入内容"));
            } else if (this.entity.content === undefined) {
              callback(new Error("请输入内容"));
            } else if (this.entity.content === "") {
              callback(new Error("请输入内容"));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
    ],
    categoryId: [
      { required: true, message: "请选择所属栏目", trigger: "change" },
    ],
    checkReleaseDate: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (this.entity.released) {
            if (this.entity.releaseDate === null) {
              callback(new Error("请选择发布时间"));
            } else if (this.entity.releaseDate === undefined) {
              callback(new Error("请选择发布时间"));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: "change",
      },
    ],
  };

  activated() {
    // 强制刷新组件
    this.refreshKey += 1;

    this.tagValues = [];
  }

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_content",
      "/cms/content",
      "/cms/content",
      this.service
    );
    data.typesName = "content-type";
    return data;
  }

  public add() {
    this.service.generateCode("cms").then((result: any) => {
      super.add();
      if (this.serviceContext.statesName === "sys-state") {
        this.entity.state = "enable";
      }
      this.entity.code = result.data;
      this.entity.creator = store.getters.loginUser.name;
    });
  }

  public newEntity() {
    const entity: Content = { contentFiles: [], deleteContentFiles: [] };
    const categoryId = this.$route.query.categoryId;
    if (categoryId) {
      entity.categoryId = Number(categoryId);
    }
    if (this.$refs.editor) {
      (this.$refs.editor as TinymceEditor).setContent("");
    }
    if (this.$refs.mobileEditor) {
      (this.$refs.mobileEditor as TinymceMobileEditor).setContent("");
    }
    entity.released = false;
    entity.red = false;
    entity.type = "content";
    entity.sortNo = 0;
    entity.extend = {};
    this.injectDetailData(entity.contentFiles!, entity.deleteContentFiles!);
    this.initExtend(entity);
    return entity;
  }

  public initOptions() {
    super.initOptions();
    const categoryService = new CategoryService();
    categoryService.loadParentCategorys(0, (data: any) => {
      this.parents = data;
    });
    const tagService = new TagService();
    tagService.loadTagsByType("content", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });
  }

  uploadFile(param: any) {
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  uploadMobileFile(param: any) {
    const path = "mobile/cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.mobileImg = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  uploadAccessory(param: any) {
    const contentFile = param.data.row as ContentFile;
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        contentFile.url = uploadUrl;
        contentFile.name = param.file.name;
        contentFile.size = param.file.size;
        contentFile.type = param.file.type;
        this.modifyRow(contentFile);
      },
      (error: Error) => {
        ElMessage.error("上传附件失败！原因：" + error);
      }
    );
  }

  public afterLoad(data: any) {
    (this.$refs.editor as TinymceEditor).setContent(data.content);
    (this.$refs.mobileEditor as TinymceMobileEditor).setContent(
      data.mobileContent
    );
    const content = this.entity as Content;
    content.deleteContentFiles = [];
    this.injectDetailData(content.contentFiles!, content.deleteContentFiles!);
    this.generateRowNo();

    if (content.tagIds) {
      const tempTagValues: number[] = [];
      const stagIds = content.tagIds?.split(",");
      stagIds.forEach((item) => {
        tempTagValues.push(Number(item));
      });
      this.tagValues = tempTagValues;
    } else {
      this.tagValues = [];
    }

    this.initExtend(content);
  }

  private changeCategory() {
    const content = this.entity as Content;
    this.initExtend(content);
  }

  private initExtend(content: Content) {
    if (content.categoryId) {
      this.service.loadEntity(
        "/api/cms/category/entity",
        { id: content.categoryId },
        (data: any) => {
          const category = data as Category;
          if (category.customId) {
            this.hasExtend = true;
            this.loadExtend(category.customId!);
          } else {
            this.customDetails = [];
            this.generalCustomDetails = [];
            this.textareaCustomDetails = [];
            this.hasExtend = false;
          }
        }
      );
    }
  }

  private loadExtend(id: number) {
    this.service.loadEntity("/api/sys/custom/entity", { id }, (data: any) => {
      const custom = data as Custom;
      this.customDetails = custom.customDetails!;
      this.generalCustomDetails = [];
      this.textareaCustomDetails = [];
      if (this.customDetails) {
        this.customDetails.forEach((item) => {
          if (item.type !== "mtext") {
            this.generalCustomDetails.push(item);
          } else {
            this.textareaCustomDetails.push(item);
          }
        });
      }
    });
  }

  private copy() {
    this.entity.content = (this.$refs.editor as TinymceEditor).getContent();
    (this.$refs.mobileEditor as TinymceMobileEditor).setContent(
      this.entity.content
    );
  }

  public beforeSave() {
    this.entity.content = (this.$refs.editor as TinymceEditor).getContent();
    this.entity.mobileContent = (
      this.$refs.mobileEditor as TinymceMobileEditor
    ).getContent();
    this.entity.tagIds = this.tagValues?.join(",");
    this.entity.extendData = JSON.stringify(this.entity.extend);
    return true;
  }

  public afterSave() {
    // this.service.staticize(this.id);
  }

  private release() {
    this.service.release(this.entity).then(
      (result) => {
        if (result.success) {
          ElMessage({ type: "success", message: "发布成功!" });
          this.load(this.id);
        } else {
          ElMessage({ type: "error", message: result.message });
        }
      },
      (error: Error) => {
        ElMessage.error("发布失败，原因：" + error.message);
      }
    );
  }

  private preview() {
    const content = this.entity as Content;
    if (!content.id) {
      ElMessage.error("无法浏览，请您保存后再浏览!");
      return;
    }
    window.open(content.url);
  }

  private pinyin() {
    const content = this.entity as Content;
    this.service.pinyin(content.title!).then((result: any) => {
      content.name = result.data;
    });
  }

  private selectCategory() {
    (this.$refs.categoryRefer as CategoryRefer).show((category: Category) => {
      const content = this.entity as Content;
      content.linkType = "category";
      content.linkId = category.id;
      content.url = category.url;
    });
  }

  private selectContent() {
    (this.$refs.contentRefer as ContentRefer).show((data: Content) => {
      const content = this.entity as Content;
      content.linkType = "content";
      content.linkId = data.id;
      content.url = data.url;
    });
  }
}
